<script>
   /*************************************************************/
   /* Widget template for preprocessing methods                 */
   /* -----------------------------------                       */
   /*************************************************************/

   import { Container, Button, ButtonCancel, ButtonUp, ButtonDown } from 'svelte-controls-basic';
	import { fade } from 'svelte/transition';


   let {
      title,
      settings,
      isOpen,
      pos,
      moveUp,
      moveDown,
      apply,
      remove,
      open,
      cancel = null,
      children
   } = $props();

</script>


{#if isOpen}
<div class="method-open" transition:fade={{duration:10}}>
   <Container><p class="title">{title}</p></Container>
   {@render children()}
   <Container label=" ">
      {#if cancel}<Button text="Cancel" onclick={cancel}/>&nbsp;{/if}
      <Button text="Save" onclick={apply}/>
   </Container>
</div>
{:else}
<Container>
   <p>
      {title}
      <!-- tabindex="0": Safari's default Tab skips a button without one -->
      <button type="button" class="settings" title="Edit" onclick={() => open(pos)}
         tabindex="0">{settings}</button>
   </p>
   <ButtonUp onclick={() => moveUp(pos)}/>
   <ButtonDown onclick={() => moveDown(pos)}/>
   <ButtonCancel title="Remove" onclick={() => remove(pos)}/>
</Container>
{/if}

<style>
   .settings {
      font: inherit;
      cursor: default;
      display: inline-block;
      border-radius: 3px;
      border: solid 1px #a0a0a0;
      color: #808080;
      background-color: #fafafa;
      padding: 0.2em 0.5em;
      margin: 0 0.5em;
   }

   .settings:hover {
      border: solid 1px #6eb8ff;
      color: #5086b9;
      background-color: #6eb8ff20;
   }

   .method-open {
      position: absolute;
      height: 100vh;
      top: 0;
      left: inherit;
      width: 340px;
      padding: 1em;
      margin-left: -18px;
      padding-top: 200px;
      background: #000000a0;
      z-index: 999;
      box-sizing: border-box;
   }
</style>

